export default __webpack_public_path__ + "a9cc8aa352d668c67728d399e77e6a9d.webp";